import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from 'client/util/baseQueryWithReauth';

export const peopleApiSlice = createApi({
  reducerPath: 'peopleReducer',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Person'],
  endpoints: builder => ({
    getPeople: builder.query({
      query: ({ survey, skip, limit, sort, filter }) =>
        `/surveys/${survey}/people?skip=${skip}&limit=${limit}&sort=${sort || ''}&filter=${filter || ''}`,
      providesTags: ['Person'],
    }),
    getPerson: builder.query({
      query: ({ survey, personId }) => `/surveys/${survey}/people/${personId}`,
    }),
    addNewPerson: builder.mutation({
      query: (survey, initialPost) => ({
        url: `/surveys/${survey}/people`,
        method: 'POST',
        body: initialPost,
      }),
      invalidatesTags: ['Person'],
    }),
    editPerson: builder.mutation({
      query: (survey, person) => ({
        url: `/surveys/${survey}/people/${person.id}`,
        method: 'PATCH',
        body: person,
      }),
    }),
    deletePerson: builder.mutation({
      query: ({ survey, personId }) => ({
        url: `/surveys/${survey}/people/${personId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Person'],
    }),
    getActivities: builder.query({
      query: ({ personId, survey, skip, limit, sort, filter }) =>
        `/surveys/${survey}/people/${personId}/activity?skip=${skip}&limit=${limit}&sort=${sort || ''}&filter=${filter || ''}`,
    }),
  }),
});

export const {
  useGetActivitiesQuery,
  useGetPeopleQuery,
  useGetPersonQuery,
  useAddNewPersonMutation,
  useEditPersonMutation,
  useDeletePersonMutation,
  reducer: peopleReducer,
} = peopleApiSlice;
